var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ListagemBase',{attrs:{"nomePlural":"Inquilinos","nomeSingular":"Inquilino","headers":_vm.headers}})
}
var staticRenderFns = []

export { render, staticRenderFns }